export interface DoujinWork {
  id: string;
  title: string;
  ip: string;
  author: string;
  tag: string[];
  cover: string;
  views: string;
  likes: string;
  chapters: number;
  status: string;
  updated: string;
  intro: string;
  palette: string;
}

export interface IpCategory {
  id: string;
  name: string;
  english: string;
  description: string;
  count: number;
  cover: string;
  tagline: string;
}

export const ipCategories: IpCategory[] = [
  {
    id: "naruto",
    name: "火影忍者",
    english: "NARUTO",
    description: "木叶之魂与忍道羁绊的同人宇宙，燃与泪并存。",
    count: 1286,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20ninja%20village%20at%20sunset%20with%20orange%20and%20crimson%20glow%2C%20silhouettes%20of%20ninjas%20on%20rooftops%2C%20bold%20manga%20brush%20strokes%2C%20dramatic%20warm%20lighting%2C%20dynamic%20composition%2C%20rich%20orange%20and%20dark%20charcoal%20palette%2C%20high%20detail%20editorial%20art&width=800&height=600&seq=ip-naruto&orientation=landscape",
    tagline: "羁绊与忍道",
  },
  {
    id: "onepiece",
    name: "海贼王",
    english: "ONE PIECE",
    description: "伟大航路上的冒险与伙伴情谊，自由与梦想的交响。",
    count: 1543,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20grand%20pirate%20ship%20sailing%20on%20a%20vast%20ocean%20at%20golden%20hour%2C%20treasure%20and%20adventure%20vibes%2C%20bold%20manga%20ink%20style%2C%20dramatic%20warm%20golden%20and%20teal%20sky%2C%20epic%20composition%2C%20high%20detail%20editorial%20art%2C%20warm%20amber%20and%20deep%20blue%20palette&width=800&height=600&seq=ip-onepiece&orientation=landscape",
    tagline: "自由与梦想",
  },
  {
    id: "jjk",
    name: "咒术回战",
    english: "JUJUTSU KAISEN",
    description: "咒力与诅咒的黑暗幻想，热血战斗的极致演绎。",
    count: 967,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20dark%20supernatural%20combat%20with%20glowing%20cursed%20energy%2C%20japanese%20shrine%20silhouette%20and%20shadows%2C%20dramatic%20high%20contrast%20manga%20art%2C%20crimson%20and%20black%20palette%20with%20electric%20accents%2C%20intense%20dynamic%20energy%2C%20high%20detail%20editorial%20illustration&width=800&height=600&seq=ip-jjk&orientation=landscape",
    tagline: "咒力与诅咒",
  },
  {
    id: "kimetsu",
    name: "鬼灭之刃",
    english: "DEMON SLAYER",
    description: "斩鬼之路的悲壮史诗，亲情与守护的温柔叙事。",
    count: 1102,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20a%20lone%20swordsman%20with%20katana%20under%20a%20red%20moon%2C%20cherry%20blossom%20petals%20and%20mist%2C%20japanese%20historical%20atmosphere%2C%20bold%20manga%20brush%20style%2C%20crimson%20red%20and%20deep%20indigo%20palette%2C%20atmospheric%20and%20cinematic%20composition%2C%20high%20detail%20editorial%20art&width=800&height=600&seq=ip-kimetsu&orientation=landscape",
    tagline: "斩鬼与守护",
  },
  {
    id: "haikyu",
    name: "排球少年",
    english: "HAIKYU!!",
    description: "球场上的汗水与青春，热血竞技的纯粹热爱。",
    count: 823,
    cover: "https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20of%20volleyball%20players%20mid-spike%20on%20a%20gym%20court%2C%20dynamic%20sports%20action%2C%20orange%20ball%20and%20warm%20gym%20lighting%2C%20bold%20energetic%20manga%20style%2C%20orange%20and%20cream%20palette%2C%20kinetic%20composition%2C%20high%20detail%20editorial%20art&width=800&height=600&seq=ip-haikyu&orientation=landscape",
    tagline: "青春与拼搏",
  },
];

export const featuredWorks: DoujinWork[] = [
  {
    id: "d-001",
    title: "木叶的黄昏",
    ip: "naruto",
    author: "晓风残月",
    tag: ["燃向", "羁绊", "长篇"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20two%20ninjas%20facing%20each%20other%20under%20a%20burning%20sunset%20village%20skyline%2C%20dramatic%20crimson%20and%20orange%20lighting%2C%20bold%20ink%20outlines%2C%20emotional%20confrontation%20scene%2C%20portrait%20book%20cover%20composition%2C%20rich%20warm%20palette%2C%20high%20detail%20illustration&width=600&height=800&seq=work-naruto-1&orientation=portrait",
    views: "18.6万",
    likes: "2.3万",
    chapters: 42,
    status: "连载中",
    updated: "2026-08-12",
    intro: "战乱后重建的木叶迎来新的危机，昔日的羁绊与新的选择交织成一场关于守护的物语。",
    palette: "from-primary-500 to-primary-700",
  },
  {
    id: "d-002",
    title: "伟大航路的尽头",
    ip: "onepiece",
    author: "海潮声",
    tag: ["冒险", "热血", "长篇"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20young%20pirate%20captain%20standing%20on%20ship%20bow%20facing%20a%20golden%20horizon%20ocean%2C%20adventurous%20mood%2C%20treasure%20map%20and%20waves%2C%20bold%20ink%20style%2C%20warm%20gold%20and%20amber%20palette%2C%20epic%20portrait%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=work-onepiece-1&orientation=portrait",
    views: "22.1万",
    likes: "3.1万",
    chapters: 58,
    status: "连载中",
    updated: "2026-08-14",
    intro: "当传说中Laugh Tale的真相逐渐浮出水面，新一代的海贼们踏上了改写历史的旅程。",
    palette: "from-accent-500 to-secondary-500",
  },
  {
    id: "d-003",
    title: "宿命之咒",
    ip: "jjk",
    author: "无量空处",
    tag: ["战斗", "黑暗", "中篇"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20sorcerer%20unleashing%20dark%20glowing%20cursed%20energy%20in%20a%20ruined%20shrine%20at%20night%2C%20dramatic%20shadows%20and%20crimson%20light%2C%20intense%20fight%20scene%2C%20bold%20high%20contrast%20ink%20style%2C%20black%20and%20crimson%20palette%2C%20portrait%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=work-jjk-1&orientation=portrait",
    views: "15.3万",
    likes: "1.9万",
    chapters: 36,
    status: "连载中",
    updated: "2026-08-13",
    intro: "被诅咒缠绕的少年在正邪之间挣扎，一场关于力量与代价的黑暗对决就此展开。",
    palette: "from-primary-700 to-background-800",
  },
  {
    id: "d-004",
    title: "月光下的剑舞",
    ip: "kimetsu",
    author: "苍雪",
    tag: ["治愈", "悲壮", "短篇"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20young%20swordsman%20holding%20katana%20under%20a%20huge%20red%20moon%2C%20cherry%20blossoms%20drifting%2C%20gentle%20yet%20sorrowful%20atmosphere%2C%20japanese%20aesthetic%2C%20bold%20brush%20style%2C%20crimson%20and%20soft%20pink%20palette%2C%20elegant%20portrait%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=work-kimetsu-1&orientation=portrait",
    views: "12.8万",
    likes: "1.6万",
    chapters: 12,
    status: "已完结",
    updated: "2026-07-28",
    intro: "在与鬼的漫长战斗中，一名剑士用温柔的剑舞守护着想要守护的人。",
    palette: "from-accent-500 to-primary-400",
  },
  {
    id: "d-005",
    title: "热血球场上的白鸟",
    ip: "haikyu",
    author: "跃起的一球",
    tag: ["竞技", "青春", "中篇"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20volleyball%20players%20diving%20and%20spiking%20in%20a%20bright%20gym%20court%2C%20energetic%20sports%20action%2C%20orange%20ball%20mid-air%2C%20warm%20gym%20lighting%2C%20bold%20dynamic%20manga%20style%2C%20orange%20and%20cream%20palette%2C%20kinetic%20portrait%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=work-haikyu-1&orientation=portrait",
    views: "9.6万",
    likes: "1.2万",
    chapters: 24,
    status: "连载中",
    updated: "2026-08-10",
    intro: "一支不被看好的球队，用一次次飞身扑救与全力扣杀，书写属于他们的全国大赛之路。",
    palette: "from-accent-400 to-accent-600",
  },
  {
    id: "d-006",
    title: "风影之约",
    ip: "naruto",
    author: "砂之爱",
    tag: ["情感", "治愈", "短篇"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20young%20sand%20ninja%20standing%20alone%20in%20a%20desert%20under%20a%20starry%20sky%2C%20contemplative%20and%20warm%20mood%2C%20wind%20and%20sand%20particles%2C%20bold%20ink%20style%2C%20amber%20and%20warm%20sand%20palette%2C%20gentle%20portrait%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=work-naruto-2&orientation=portrait",
    views: "8.9万",
    likes: "9800",
    chapters: 8,
    status: "已完结",
    updated: "2026-07-20",
    intro: "在孤寂的砂隐之村，一个关于信任与约定慢慢温暖起来的故事。",
    palette: "from-secondary-500 to-accent-600",
  },
];

export const latestUpdates: DoujinWork[] = [
  {
    id: "u-001",
    title: "镜面之外的你",
    ip: "jjk",
    author: "黑白格",
    tag: ["悬疑", "日常"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20two%20mirror-like%20reflections%20of%20a%20young%20sorcerer%20in%20dark%20urban%20night%2C%20mysterious%20and%20subtle%20mood%2C%20glowing%20cursed%20aura%2C%20bold%20contrast%20ink%20style%2C%20dark%20blue%20and%20crimson%20palette%2C%20portrait%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=work-jjk-2&orientation=portrait",
    views: "7.2万",
    likes: "8400",
    chapters: 19,
    status: "连载中",
    updated: "2026-08-15",
    intro: "镜子里多了一个会说话的自己，是诅咒，还是另一个真实的答案？",
    palette: "from-primary-500 to-background-800",
  },
  {
    id: "u-002",
    title: "海风与约定",
    ip: "onepiece",
    author: "航迹云",
    tag: ["冒险", "日常"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20two%20pirate%20crewmates%20sharing%20a%20small%20campfire%20on%20a%20beach%20at%20night%2C%20warm%20and%20friendly%20mood%2C%20starry%20sky%20and%20calm%20sea%2C%20bold%20ink%20style%2C%20warm%20amber%20and%20navy%20palette%2C%20cozy%20portrait%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=work-onepiece-2&orientation=portrait",
    views: "6.5万",
    likes: "7600",
    chapters: 15,
    status: "连载中",
    updated: "2026-08-14",
    intro: "停泊在某个小岛的夜晚，关于梦想与约定的对话在海风中轻轻展开。",
    palette: "from-accent-500 to-background-700",
  },
  {
    id: "u-003",
    title: "球网对面的约定",
    ip: "haikyu",
    author: "托球手",
    tag: ["竞技", "情感"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20two%20volleyball%20rivals%20shaking%20hands%20across%20the%20net%20after%20a%20match%2C%20sweat%20and%20determination%2C%20warm%20gym%20lighting%2C%20sportsmanship%20mood%2C%20bold%20energetic%20manga%20style%2C%20orange%20and%20warm%20palette%2C%20portrait%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=work-haikyu-2&orientation=portrait",
    views: "5.8万",
    likes: "6900",
    chapters: 21,
    status: "连载中",
    updated: "2026-08-12",
    intro: "对手也可以是朋友，一场比赛之后，隔网相望的少年们许下了新的约定。",
    palette: "from-accent-400 to-secondary-500",
  },
  {
    id: "u-004",
    title: "炭与雪",
    ip: "kimetsu",
    author: "烬火",
    tag: ["治愈", "悲壮"],
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20art%20of%20a%20gentle%20swordsman%20carrying%20a%20sleeping%20child%20through%20falling%20snow%20in%20a%20quiet%20village%2C%20protective%20and%20warm%20mood%2C%20moonlight%20and%20snowflakes%2C%20japanese%20aesthetic%2C%20soft%20brush%20style%2C%20muted%20crimson%20and%20white%20palette%2C%20gentle%20portrait%20composition%2C%20high%20detail%20illustration&width=600&height=800&seq=work-kimetsu-2&orientation=portrait",
    views: "5.1万",
    likes: "6200",
    chapters: 10,
    status: "已完结",
    updated: "2026-08-08",
    intro: "在漫天飞雪的夜里，一把剑、一个人，守护着一个与鬼无关的平凡承诺。",
    palette: "from-primary-400 to-secondary-300",
  },
];

export const faqItems = [
  {
    q: "同人动漫作品可以免费阅读吗？",
    a: "本站收录的同人漫画作品大部分支持免费阅读，部分长篇连载作品会在最新章节设置阅读门槛，用于支持作者的持续创作。所有作品均标注了作者与来源，尊重原创者的劳动成果。",
  },
  {
    q: "网站按哪些IP进行分类整理？",
    a: "目前主要覆盖火影忍者、海贼王、咒术回战、鬼灭之刃、排球少年五大热门IP，未来会根据读者需求持续扩充更多经典作品的同人合集，并按IP、作者、题材等维度精细分类，方便快速定位。",
  },
  {
    q: "我能投稿自己的同人作品吗？",
    a: "非常欢迎！我们长期向同人创作者开放投稿通道，可通过首页的订阅与投稿表单留下你的联系方式与作品简介，审核通过后我们会安排上线展示，并提供分类收录与推荐位支持。",
  },
  {
    q: "作品会持续更新吗？",
    a: "会。我们与多位同人作者保持长期合作，热门长篇会保持稳定的更新频率，每周都有新作上线。你可以关注对应IP分类页，第一时间看到最新章节与连载进度。",
  },
  {
    q: "如何收藏喜欢的小说与漫画？",
    a: "登录后点击作品卡片的收藏按钮即可加入个人书单，系统会为你同步记录追更状态、阅读进度与最新更新提醒，方便随时回到追读的章节。",
  },
  {
    q: "网站的内容是否尊重原作版权？",
    a: "本站仅作为同人二创作品的展示与聚合平台，所有内容均为爱好者基于原作的二次创作，我们严格遵守版权规范，尊重原作版权方，若涉及侵权问题会第一时间下架处理。",
  },
];